export function ValueStateFunnel({ funnel, testId }) {
  if (!funnel) return null;
  const max = Math.max(...funnel.stages.map((s) => s.value_lakh), 1);
  return (
    <div className="space-y-2" data-testid={testId}>
      {funnel.stages.map((s, i) => {
        const isVerified = s.name === "Verified";
        const isIdentified = s.name === "Identified";
        return (
          <div key={s.name} data-testid={`funnel-stage-${s.name.toLowerCase()}`}>
            <div className="flex items-baseline justify-between">
              <span className={`text-xs font-heading ${isIdentified ? "text-[var(--oim-text-muted)]" : "text-[var(--oim-text-secondary)]"}`}>{s.name}</span>
              <span
                className="font-mono-data"
                style={isVerified ? { color: "var(--oim-green)", fontSize: "1.1rem", fontWeight: 700 } : { color: "var(--oim-text)", fontSize: "0.85rem" }}
              >
                ₹{s.value_lakh}L <span className="text-[10px] text-[var(--oim-text-dim)]">{s.count}</span>
              </span>
            </div>
            <div className="h-1.5 rounded-full mt-1" style={{ backgroundColor: "var(--oim-surface-softer)" }}>
              <div className="h-1.5 rounded-full" style={{ width: `${(s.value_lakh / max) * 100}%`, backgroundColor: isVerified ? "var(--oim-green)" : "var(--oim-text-muted)" }} />
            </div>
            {s.caption && <div className="text-[9px] text-[var(--oim-text-dim)] mt-0.5">{s.caption}</div>}
          </div>
        );
      })}
    </div>
  );
}
